import { Field } from '../StatsbidragGlobals/statsbidrag.types';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import {
  calculationComponentModel,
  calculationComponentModel2,
  ColumnTypeGroup,
  Header,
} from './calculationComponents.types';
import { DynamicCell } from './AutoSum/AutoSum';

export function serializeComponent(columns: any, values: any, sum?: any, heading?: string, subheadings?: string[]) {
  return JSON.stringify({
    heading,
    columns,
    values,
    sum,
    subheadings,
  });
}

export function updateField(field: FormField<any>, fieldsClone: Field[][]) {
  let fieldToUpdate: Field;
  fieldsClone.some((arr) => {
    fieldToUpdate = arr.find((x) => x.name === field.fieldName);
    return fieldToUpdate !== undefined;
  });
  fieldToUpdate.value = field.value;
  return fieldToUpdate;
}

export function getAsNumber(number: any) {
  return Number(number.toString().replace(/\s/g, ''));
}

export function getInitialFieldsFromJsonData(
  jsonModel: calculationComponentModel,
  initialFields: Field[][],
  fieldRowCallback: () => Field[],
  preDefs?: DynamicCell[]
) {
  if (!preDefs) {
    // No preDefs, reset initialFields to empty to remove the initial object
    initialFields = [];
  }

  jsonModel.values.forEach((valueObjArr) => {
    if (preDefs) {
      // We have some preDefs already in the initialFields but they need values
      let foundMatch = false;
      initialFields.forEach((arr) => {
        let field = arr.find((def) => def.value === valueObjArr[0].value);

        if (field) {
          // We have a match with preDefs
          foundMatch = true;
          for (let i = 0; i < arr.length; i++) {
            arr[i].value = valueObjArr[i].value;
          }
        }
      });

      if (!foundMatch) {
        // In case of no match, we need to create a new item to the list
        addFieldRowFromJsonData(valueObjArr, initialFields, fieldRowCallback);
      }
    } else {
      // Add each json value to initialFields
      addFieldRowFromJsonData(valueObjArr, initialFields, fieldRowCallback);
    }
  });
  return initialFields;
}

export function addFieldRowFromJsonData(
  value: ValueObject[],
  initialFields: Field[][],
  fieldRowCallback: () => Field[]
) {
  let fieldArr = fieldRowCallback();
  fieldArr.forEach((field, index) => {
    field.value = value[index].value;
  });
  initialFields.push(fieldArr);
}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export interface ValueObject {
  value: any;
  visible: boolean;
}

export function valueObject(value: any, visible: boolean): ValueObject {
  return { value, visible };
}

export interface IJsonDataStuctures {
  headerDefinitions: Header[];
  columnTypeGroups: ColumnTypeGroup[];
}

export function getSerializedXmlInputComponent(
  fields: Field[][],
  model: calculationComponentModel2,
  jsonSerializetoMainContentForXmlInput: (fields: Field[][], jsonDataStructures: IJsonDataStuctures) => void
) {
  const definition = model.columnDefinitions;
  const data: IJsonDataStuctures = {
    headerDefinitions: [],
    columnTypeGroups: [],
  };
  jsonSerializetoMainContentForXmlInput(fields, data);

  tryAddDataInput(model.headerDefinitions, data.headerDefinitions);
  tryAddDataInput(definition.columnTypeGroups, data.columnTypeGroups);

  const serializedModel = JSON.stringify(model);
  return serializedModel;
}

function tryAddDataInput(modelTarget: any[], dataInput: any[]) {
  if (dataInput.length > 0) {
    modelTarget.push(...dataInput);
  }
}
